import { Select } from '@mantine/core'
import { useTranslation } from 'react-i18next'

export default function LocaleSelect({ label }) {
    const { i18n } = useTranslation()

    const changeLanguage = (language) => {
        i18n.changeLanguage(language)
        localStorage.setItem('language', language)
    }

    return (
        <Select
            data={[
                {
                    value: 'en',
                    label: 'English',
                },
                {
                    value: 'fr',
                    label: 'Français',
                },
                {
                    value: 'ja',
                    label: '日本語',
                },
                {
                    value: 'de',
                    label: 'Deutsch',
                },
                {
                    value: 'nb',
                    label: 'Norsk',
                },
            ]}
            value={i18n.language}
            label={label}
            onChange={changeLanguage}
            allowDeselect={false}
        />
    )
}
